import { defineStore } from 'pinia'
import moment from 'moment'

const defaultState = () => ({
    sessionExpiry: '',
    isSessionExpiringToday: false,
    isSessionExpiringHour: false,
})

export const useSessionStore = defineStore('session', {
    state: () => ({
        ...defaultState(),
    }),
    actions: {
        resetSession() {
            Object.assign(this, defaultState())
        },
        setSession(session) {
            this.sessionExpiry = session || ''
            this.updateExpiryFlags(session)
        },
        setSessionExpiry(session) {
            this.setSession(session)
        },
        setIsSessionExpiringToday(value) {
            this.isSessionExpiringToday = Boolean(value)
        },
        setIsSessionExpiringHour(value) {
            this.isSessionExpiringHour = Boolean(value)
        },
        updateExpiryFlags(session) {
            const expiryValue = session || this.sessionExpiry
            if (!expiryValue || !moment(expiryValue).isValid()) {
                this.isSessionExpiringToday = false
                this.isSessionExpiringHour = false
                return
            }

            const duration = moment.duration(moment(expiryValue).diff(moment.now()))
            const expiryHours = duration.asHours()
            const expiryMinutes = duration.asMinutes()

            this.isSessionExpiringToday = expiryHours < 8
            this.isSessionExpiringHour = expiryMinutes < 60 && expiryMinutes > 0
        },
    },
})
